<template>
    <accordion-item>
        <h2 slot="header">
            Miscellaneous (Treatments, etc) &mdash; {{currencyFormat(value)}}
        </h2>
        <p>
            This head of loss is based on an average from claims of a similar type. Where there is insufficient data
            within the tool to derive an average a figure of £5,000 is applied.
        </p>
    </accordion-item>
</template>

<script>
    import AccordionItem from "components/accordion/AccordionItem";
    import currencyFormat from "mixins/currencyFormat";

    export default {
        name: "misc-modal",
        props: {
            value: {
                required: true
            },
            dateOfDeath: {
                type: String
            }
        },
        mixins: [
            currencyFormat
        ],
        components: {
            AccordionItem
        }
    }
</script>


// WEBPACK FOOTER //
// MiscModal.vue?81df4052